module.exports = __webpack_public_path__ + "static/r3c2-fe019309a39b30ecdb5597eea6bf7974.png";